<ng-container *ngIf="!!tag?.color">
  <div #color class="color"></div>
</ng-container>
<label>
  {{ tag?.label }}
  <ng-content></ng-content>
</label>

<!-- && !remove.observed -->
<span *ngIf="plus && !active">
  <button avButton ofType="icon" size="xxs" data-tid="tag/add">
    <av-icon name="plus"></av-icon>
  </button>
</span>

<span *ngIf="actionIcon">
  <button avButton ofType="icon" size="xxs" data-tid="tag/action">
    <av-icon [name]="actionIcon"></av-icon>
  </button>
</span>

<!-- || remove.observed -->
<ng-container *ngIf="active">
  <span>
    <button
      class="remove"
      avButton
      ofType="icon"
      size="xxs"
      (click)="tryRemove($event)"
      data-tid="tag/remove"
    >
      <av-icon name="close-big"></av-icon>
    </button>
  </span>
  <av-icon
    class="tick"
    [mode]="isLight() ? 'dark' : 'light'"
    name="tick"
  ></av-icon>
</ng-container>
